const DIGITS = 2;

export const getCurrencySymbol = (locale, currency) =>
  (0)
    .toLocaleString(locale, {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, "")
    .trim();

export const currency =
  (locale, currency) =>
  (value = null, digits = DIGITS) => {
    const currencyCode = currency || "BRL";
    return value === null
      ? getCurrencySymbol(locale, currencyCode)
      : value.toLocaleString(locale, {
          style: "currency",
          currency: currencyCode,
          minimumFractionDigits: digits,
          maximumFractionDigits: digits,
        });
  };
